import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./index.css";

// Assets
import contact from "../assests/careers/contact.svg";
import build from "../assests/careers/building.svg";
import minLogo from "../assests/aboutImages/images.svg";
import talentIcon from "../assests/aboutImages/talent.svg";
import innovationIcon from "../assests/aboutImages/innovation.svg";
import growthIcon from "../assests/aboutImages/global.svg";
import careersHero from "../assests/careers/careersHome.png";
import researchLab from "../assests/careers/researchLab.png";
import technicalIcon from "../assests/careers/technical.svg";
import leadershipIcon from "../assests/careers/leadership.svg";
import crossFuncIcon from "../assests/careers/corss-functional.svg";
import regularIcon from "../assests/careers/regular.svg";
import globalMarketIcon from "../assests/careers/gloabalMarket.svg";
import performanceIcon from "../assests/careers/performance.svg";
import graduateIcon from "../assests/careers/graduate.svg";
import specialistIcon from "../assests/careers/specialist.svg";
import managerIcon from "../assests/careers/manager.svg";
import leaderIcon from "../assests/careers/leader.svg";
import logo from "../assests/careers/images.svg";
import whyViyashIcon from "../assests/careers/whyviyash.svg";
import coreValues from "../assests/aboutImages/coreValues.png";
import equalIcon from "../assests/careers/equal.svg";
import genderIcon from "../assests/careers/gender.svg";
import safeIcon from "../assests/careers/safe.svg";
import ethicalIcon from "../assests/careers/ethical.svg";
import internationalIcon from "../assests/careers/international.svg";
import teamImage from "../assests/careers/doctor.png";
import global from "../assests/careers/global_exposure.svg";
import driven from "../assests/careers/Driven.svg";
import strong from "../assests/careers/strong.svg";
import sustainable from "../assests/careers/sustainable.svg";
import { FiUpload, FiFileText, FiCheckCircle } from 'react-icons/fi';
import timeIcon from "../assests/careers/time.svg";
import appIcon from "../assests/careers/application.svg";
import companyIcon from "../assests/careers/company.svg";
import linkedinIcon from "../assests/careers/linkdin.svg";
import nameIcon from "../assests/careers/contacts.svg";
import mailIcon from "../assests/careers/mail.svg";
import phoneIcon from "../assests/careers/phone.svg";
import locationIcon from "../assests/careers/map_location.svg";

export function useScrollAnimation() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(element);
                }
            },
            { threshold: 0.2 }
        );

        if (element) observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, visible];
}

// Custom hook for counter animation
function useCounter(target, duration = 1500) {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const tick = (now) => {
                        const elapsed = now - start;
                        const progress = Math.min(elapsed / duration, 1);
                        setCount(Math.floor(progress * target));
                        if (progress < 1) requestAnimationFrame(tick);
                        else setCount(target);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.3 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [target, duration]);

    return { count, ref };
}

// Flexible animated counter — handles "3000+", "150+", "10", etc.
function AnimatedCounter({ value, className }) {
    const match = value.match(/^([^0-9]*)([\d]+(?:\.\d+)?)(.*)$/);
    const prefix = match ? match[1] : '';
    const numeric = match ? parseFloat(match[2].replace(/,/g, '')) : 0;
    const suffix = match ? match[3] : value;
    const isFloat = String(match?.[2]).includes('.');
    const { count, ref } = useCounter(numeric, 1800);

    return (
        <span ref={ref} className={className}>
            {prefix}{isFloat ? count.toFixed(1) : Math.floor(count).toLocaleString()}{suffix}
        </span>
    );
}
const data = [
    {
        image: global,
        title: "Global Exposure",
        desc: "Work across a portfolio spanning 150+ countries, with opportunities for international assignments.",
        color: "blue",
    },
    {
        image: driven,
        title: "Innovation-Driven Culture",
        desc: "Contribute to novel API synthesis, CDMO innovation, and formulation science at the frontier of pharma.",
        color: "green",
    },
    {
        image: strong,
        title: "Strong Governance & Ethics",
        desc: "Join an organisation governed by transparent policies, strict compliance, and ethical leadership.",
        color: "purple",
    },
    {
        image: sustainable,
        title: "Sustainable Growth Platform",
        desc: "Be part of a company growing across API, CDMO, and Animal Health with a clear long-term vision.",
        color: "orange",
    },
];
const HomeIcon = () => (
    <svg className="careers-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Careers = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [activeCategory, setActiveCategory] = useState("All");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [formStatus, setFormStatus] = useState("idle"); // idle, submitting, success
    const [fileName, setFileName] = useState("");
    const [resumeName, setResumeName] = useState("");
    const [coverLetterName, setCoverLetterName] = useState("");
    const [resumeData, setResumeData] = useState(null);
    const [coverLetterData, setCoverLetterData] = useState(null);

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        location: "",
        position: "",
        experience: "",
        company: "",
        linkedIn: "",
        whyJoin: ""
    });
    const name = formData.fullName.trim();
    const pos = formData.position.trim();

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phoneNumber") {
            const numericValue = value.replace(/\D/g, "").slice(0, 15);
            setFormData(prev => ({ ...prev, [name]: numericValue }));
        }
        else if (name === "fullName") {
            // Allow only letters + regular space for full name
            const cleanedValue = value.replace(/[^A-Za-z ]/g, "");
            setFormData(prev => ({ ...prev, [name]: cleanedValue }));
        }
        else if (name === "position") {
            const cleanedValue = value.replace(/[^A-Za-z ]/g, "");
            setFormData(prev => ({ ...prev, [name]: cleanedValue }));
        }
        else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB limit

            if (file.size > MAX_FILE_SIZE) {
                setErrors(prev => ({ ...prev, [field]: "File size must be strictly less than 2MB" }));
                e.target.value = null; // Clear the input visually
                if (field === "resume") {
                    setResumeName("");
                    setResumeData(null);
                } else {
                    setCoverLetterName("");
                    setCoverLetterData(null);
                }
                return;
            }

            if (field === "resume") {
                setResumeName(file.name);
                setResumeData(file);
            } else {
                setCoverLetterName(file.name);
                setCoverLetterData(file);
            }
            if (errors[field]) {
                setErrors(prev => ({ ...prev, [field]: "" }));
            }
        } else {
            if (field === "resume") {
                setResumeName("");
                setResumeData(null);
            } else {
                setCoverLetterName("");
                setCoverLetterData(null);
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // Name
        if (!name) {
            newErrors.fullName = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(name)) {
            newErrors.fullName = "Only letters and spaces allowed";
        }

        // Email
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        // Phone
        if (!/^[0-9]{7,15}$/.test(formData.phoneNumber)) {
            newErrors.phoneNumber = "Phone Number must be 7 to 15 digits";
        }

        // Position — only validate if user typed it (general form), not when job is pre-selected (modal)
        if (!selectedJob) {
            const pos = formData.position.trim();
            if (!pos) {
                newErrors.position = "Position is required";
            }
        }

        // Resume
        if (!resumeData) {
            newErrors.resume = "Resume (PDF) is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setFormStatus("submitting");

        try {
            const requestData = new FormData();

            // Explicitly appending data 
            requestData.append("fullName", formData.fullName.trim());
            requestData.append("email", formData.email.trim());
            requestData.append("phoneNumber", formData.phoneNumber.trim());
            requestData.append("location", formData.location.trim());

            // Determine the position depending on whether this is the general form or a specific job modal
            const rawPosition = selectedJob ? selectedJob.title : formData.position;
            // Sanitize: keep only letters and spaces (backend requires ^[A-Za-z\s]+$)
            const finalPosition = rawPosition.trim().replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ").trim();

            // Sending correct position key for backend validation
            requestData.append("applying", finalPosition);

            // To ensure compatibility if some endpoints use 'firstName'
            requestData.append("firstName", formData.fullName.trim());

            // Sanitize experience: strip non-letter/space chars (backend may reject "1+ Years" due to "+")
            const safeExperience = formData.experience.replace(/[^A-Za-z0-9\s]/g, "").trim();
            requestData.append("experience", safeExperience);
            requestData.append("company", formData.company.trim());
            requestData.append("linkedIn", formData.linkedIn.trim());
            requestData.append("whyJoin", formData.whyJoin.trim().replace(/[\r\n]+/g, " "));

            if (selectedJob) {
                // Sanitize appliedJobTitle the same way — strip special chars like & that fail backend validation
                const safeJobTitle = selectedJob.title.trim().replace(/[^A-Za-z\s]/g, "").replace(/\s+/g, " ").trim();
                requestData.append("appliedJobTitle", safeJobTitle);
            }

            if (resumeData) requestData.append("resume", resumeData);
            if (coverLetterData) requestData.append("coverLetter", coverLetterData);

            // REPLACE THE URL BELOW with your actual backend API endpoint URL
            const response = await fetch("https://viyash.whysocial.in/apis/joinOurTeam", {
                method: "POST",
                body: requestData,
            });

            if (!response.ok) {
                // Parse backend error details for better diagnostics
                let errMsg = "Failed to submit the form. Please try again later.";
                try {
                    const errBody = await response.json();
                    if (errBody?.errors?.length) {
                        errMsg = errBody.errors.join("\n");
                    } else if (errBody?.message) {
                        errMsg = errBody.message;
                    }
                } catch (_) { }
                throw new Error(errMsg);
            }

            setFormStatus("success");

            setTimeout(() => {
                setIsModalOpen(false);
                setFormStatus("idle");
                setFormData({
                    fullName: "",
                    email: "",
                    phoneNumber: "",
                    location: "",
                    position: "",
                    experience: "",
                    company: "",
                    linkedIn: "",
                    whyJoin: ""
                });
                setResumeName("");
                setResumeData(null);
                setCoverLetterName("");
                setCoverLetterData(null);
            }, 3000);

        } catch (error) {
            console.error(error);
            alert(error.message);
            setFormStatus("idle");
        }
    };
    ;

    const [refHero, visibleHero] = useScrollAnimation();
    const [refWhy, visibleWhy] = useScrollAnimation();
    const [refOpenings, visibleOpenings] = useScrollAnimation();
    const [refCulture, visibleCulture] = useScrollAnimation();
    const [refCTA, visibleCTA] = useScrollAnimation();

    const lifeAtViyashRef = useRef(null);
    const learningGrowthRef = useRef(null);
    const diversityInclusionRef = useRef(null);
    const applyNowRef = useRef(null);
    const [activeTab, setActiveTab] = useState("Life at Viyash");

    const scrollToSection = (ref, tabName) => {
        setActiveTab(tabName);
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const jobs = [
        { id: 1, title: "Senior Research Scientist", department: "R&D", location: "Visakhapatnam", type: "Full-time" },
        { id: 2, title: "Quality Assurance Lead", department: "Quality", location: "Mumbai", type: "Full-time" },
        { id: 3, title: "Plant Operator", department: "Manufacturing", location: "Hyderabad", type: "Full-time" },
        { id: 4, title: "HR Manager", department: "Human Resources", location: "Visakhapatnam", type: "Full-time" },
        { id: 5, title: "Supply Chain Coordinator", department: "Logistics", location: "Mumbai", type: "Full-time" },
        { id: 6, title: "Analytical Chemist", department: "R&D", location: "Hyderabad", type: "Full-time" },
    ];

    const categories = ["All", "R&D", "Quality", "Manufacturing", "Human Resources", "Logistics"];
    const CAREERS_STATS = [
        { val: "3000+", lab: "Global Employees" },
        { val: "15", lab: "Manufacturing Sites" },
        { val: "150+", lab: "Countries Served" },
        { val: "10", lab: "USFDA Approved Units" },
    ];

    const filteredJobs = jobs.filter(job =>
        (activeCategory === "All" || job.department === activeCategory) &&
        (job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            job.location.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleApply = (job) => {
        setSelectedJob(job);
        setIsModalOpen(true);
        setFormStatus("idle");
    };

    return (
        <div className="careers-page">
            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 1 – HERO (Replicated from Manufacturing Quality)
          ══════════════════════════════════════════════════════════════════════ */}
            <section ref={refHero} className={`careers-hero-section1 ${visibleHero ? "reveal-visible" : "reveal"}`}>
                <img
                    src={careersHero}
                    alt="Careers at Viyash"
                    className="careers-hero-section1__bg-image"
                />
                <div className="careers-hero-section1__overlay" />

                <div className="careers-hero-section1__content">
                    <h1 className="careers-hero-section1__title">
                        Careers at <br />
                        <span className="careers-hero-title-highlight">Viyash Scientific</span>
                    </h1>
                    <p className="careers-hero-section1__subtitle">
                        Innovating Healthcare. Building Futures.
                    </p>
                    <p className="careers-hero-section1__description">
                        At Viyash Scientific, we are driven by science, integrity, and global impact. Join a team shaping the future of pharmaceutical excellence across Human and Animal Health.
                    </p>


                    {/* CTA */}

                </div>
                <div className={`careers-stats-bar ${visibleHero ? "reveal-visible" : "reveal"}`}>
                    <div className="careers-stats-bar__container">
                        {CAREERS_STATS.map((s) => (
                            <div key={s.lab} className="careers-stats-bar__item">
                                <div className="careers-stats-bar__value">
                                    <AnimatedCounter value={s.val} />
                                </div>
                                <div className="careers-stats-bar__label">{s.lab}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* STATS BAR */}


            {/* BREADCRUMB */}
            <div className="careers-breadcrumb-container">
                <div className="careers-breadcrumb-wrapper">
                    <Link to="/" className="careers-breadcrumb-link careers-home-link">
                        <HomeIcon />
                        Home
                    </Link>
                    <span className="careers-breadcrumb-separator">›</span>
                    <span className="careers-breadcrumb-current">Careers</span>
                </div>
            </div>
            <div className="career-tabs">
                <span
                    className={activeTab === "Life at Viyash" ? "active" : ""}
                    onClick={() => scrollToSection(lifeAtViyashRef, "Life at Viyash")}
                >
                    Life at Viyash
                </span>
                <span
                    className={activeTab === "Learning & Growth" ? "active" : ""}
                    onClick={() => scrollToSection(learningGrowthRef, "Learning & Growth")}
                >
                    Learning & Growth
                </span>
                <span
                    className={activeTab === "Diversity & Inclusion" ? "active" : ""}
                    onClick={() => scrollToSection(diversityInclusionRef, "Diversity & Inclusion")}
                >
                    Diversity & Inclusion
                </span>
                <span
                    className={activeTab === "Apply Now" ? "active" : ""}
                    onClick={() => scrollToSection(applyNowRef, "Apply Now")}
                >
                    Apply Now
                </span>
            </div>

            <section className="careers-section" ref={lifeAtViyashRef}>

                {/* NAV TABS */}


                {/* TITLE */}
                <h2 className="career-title">A Place to Grow, Innovate & Lead</h2>

                <div className="career-divider">
                    <span className="line left"></span>
                    <span className="logo-dot"><img src={minLogo} alt="" /></span>
                    <span className="line right"></span>
                </div>

                <p className="career-subtitle">
                    Discover what it means to be part of a globally integrated pharmaceutical enterprise.
                </p>

                {/* GRID SECTION */}
                <div className="career-grid">

                    {/* IMAGE */}
                    <div className="career-image">
                        <img src={researchLab} alt="R&D Labs" />
                        <div className="image-caption">
                            <h4>R&D & Research Labs</h4>
                            <p>Cutting-edge laboratory environments driving API innovation</p>
                        </div>
                    </div>

                    {/* WHY VIYASH */}
                    <div className="career-why">
                        <h3>Why Viyash?</h3>

                        <ul>
                            <li><img src={whyViyashIcon} alt="" /> Collaborative and innovation-driven work culture</li>
                            <li><img src={whyViyashIcon} alt="" /> Global exposure across 150+ countries and markets</li>
                            <li><img src={whyViyashIcon} alt="" /> Integrated Human & Animal Health operations</li>
                            <li><img src={whyViyashIcon} alt="" /> Ethical, compliance-driven work environment</li>
                            <li><img src={whyViyashIcon} alt="" /> Safety-first manufacturing culture at all sites</li>
                            <li><img src={whyViyashIcon} alt="" /> Fully backward-integrated pharmaceutical operations</li>
                        </ul>

                        <div className="career-stats">
                            <div className="stat blue">
                                <h3><AnimatedCounter value="3000+" /></h3>
                                <p>Global Employees</p>
                            </div>

                            <div className="stat green">
                                <h3><AnimatedCounter value="15" /></h3>
                                <p>Manufacturing Sites</p>
                            </div>

                            <div className="stat purple">
                                <h3><AnimatedCounter value="150+" /></h3>
                                <p>Countries Served</p>
                            </div>

                            <div className="stat orange">
                                <h3><AnimatedCounter value="10" /></h3>
                                <p>USFDA Approved Units</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* INVEST SECTION */}
                <h2 className="career-title second">Invest in Your Future</h2>

                <div className="career-divider">
                    <span className="line left"></span>
                    <span className="logo-dot"><img src={minLogo} alt="" /></span>
                    <span className="line right"></span>
                </div>

                <p className="career-subtitle">
                    We invest in structured development programs designed to nurture scientific excellence and leadership capabilities at every career stage.
                </p>

                {/* FEATURE CARDS */}
                <div className="career-cards">

                    <div className="career-card blue">
                        <div className="career-card-icon">
                            <img src={technicalIcon} alt="Technical" />
                        </div>
                        <h4>Technical Skill Development</h4>
                        <p>Hands-on programs in API synthesis, analytical science, and manufacturing technology.</p>
                    </div>

                    <div className="career-card green">
                        <div className="career-card-icon">
                            <img src={leadershipIcon} alt="Leadership" />
                        </div>
                        <h4>Leadership & Management</h4>
                        <p>Structured leadership pipelines from team lead to senior management.</p>
                    </div>

                    <div className="career-card purple">
                        <div className="career-card-icon">
                            <img src={crossFuncIcon} alt="Cross-functional" />
                        </div>
                        <h4>Cross-Functional Exposure</h4>
                        <p>Rotation programs spanning R&D, manufacturing, quality, and commercial functions.</p>
                    </div>

                    <div className="career-card red">
                        <div className="career-card-icon">
                            <img src={regularIcon} alt="Regulatory" />
                        </div>
                        <h4>Regulatory & Compliance</h4>
                        <p>GMP, ICH, USFDA, and EMA regulatory training for all technical staff.</p>
                    </div>

                    <div className="career-card orange">
                        <div className="career-card-icon">
                            <img src={globalMarketIcon} alt="Global Market" />
                        </div>
                        <h4>Global Market Exposure</h4>
                        <p>International assignments and cross-border project participation.</p>
                    </div>

                    <div className="career-card teal">
                        <div className="career-card-icon">
                            <img src={performanceIcon} alt="Performance" />
                        </div>
                        <h4>Performance-Based Growth</h4>
                        <p>Transparent merit-driven promotion system with clear career milestones.</p>
                    </div>

                </div>

                {/* CAREER PATH */}
                <div className="career-path-container" ref={learningGrowthRef}>
                    <div className="career-path-header">
                        <div className="path-header-content">
                            <div className="path-header-icon">
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                                    <polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                            </div>
                            <div className="path-header-text">
                                <h4>Career Growth Path</h4>
                                <p>A structured progression from graduate to global leader</p>
                            </div>
                        </div>
                    </div>
                    <div className="career-path-content">
                        <div className="path-line">
                            <div className="path-item">
                                <div className="path-node">
                                    <img src={graduateIcon} alt="Graduate" />
                                </div>
                                <div className="path-info">
                                    <h5>Graduate</h5>
                                    <p>Onboarding & foundational training</p>
                                </div>
                            </div>

                            <div className="path-arrow">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </div>

                            <div className="path-item">
                                <div className="path-node">
                                    <img src={specialistIcon} alt="Specialist" />
                                </div>
                                <div className="path-info">
                                    <h5>Specialist</h5>
                                    <p>Technical expertise & project ownership</p>
                                </div>
                            </div>

                            <div className="path-arrow">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </div>

                            <div className="path-item">
                                <div className="path-node">
                                    <img src={managerIcon} alt="Manager" />
                                </div>
                                <div className="path-info">
                                    <h5>Manager</h5>
                                    <p>Team leadership & cross-functional scope</p>
                                </div>
                            </div>

                            <div className="path-arrow">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </div>

                            <div className="path-item">
                                <div className="path-node">
                                    <img src={leaderIcon} alt="Leader" />
                                </div>
                                <div className="path-info">
                                    <h5>Leader</h5>
                                    <p>Strategic influence & organisational impact</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            {/* Openings Section (Restored) */}


            {/* Application Modal (Restored) */}
            {isModalOpen && (
                <div className="careers-modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="careers-modal-card" onClick={(e) => e.stopPropagation()}>
                        <button className="careers-modal-close" onClick={() => setIsModalOpen(false)}>✕</button>

                        {formStatus === "success" ? (
                            <div className="careers-modal-success">
                                <div className="success-icon">✓</div>
                                <h2>Application Sent!</h2>
                                <p>Thank you for applying for the <strong>{selectedJob?.title}</strong> position. Our team will review your application and get back to you soon.</p>
                                <button className="careers-hero-section1__cta" onClick={() => setIsModalOpen(false)}>Close</button>
                            </div>
                        ) : (
                            <>
                                <div className="careers-modal-header">
                                    <h2>Apply for Role</h2>
                                    <p className="job-title-highlight">{selectedJob?.title}</p>
                                    <div className="job-meta-tag">
                                        <span>{selectedJob?.department}</span>
                                        <img src="" alt="" />
                                        <span>{selectedJob?.location}</span>
                                    </div>
                                </div>

                                <form className="careers-modal-form" onSubmit={handleFormSubmit}>
                                    <div className="form-group-row">
                                        <div className="form-group">
                                            <label>Full Name *</label>
                                            <input type="text" name="fullName" required placeholder="John Doe" value={formData.fullName} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Email Address *</label>
                                            <input type="email" name="email" required placeholder="john@example.com" value={formData.email} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="form-group-row">
                                        <div className="form-group">
                                            <label>Phone Number *</label>
                                            <input type="tel" name="phoneNumber" required placeholder="+91 XXXXX XXXXX" value={formData.phoneNumber} onChange={handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Upload CV (PDF) *</label>
                                            <div className="file-upload-wrapper">
                                                <input
                                                    type="file"
                                                    required
                                                    accept=".pdf,.doc,.docx"
                                                    onChange={(e) => handleFileChange(e, "resume")}
                                                />
                                                <div className="file-upload-overlay">
                                                    <span>{resumeName || "Choose File"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Cover Note / Message</label>
                                        <textarea name="whyJoin" rows="4" placeholder="Tell us why you're a great fit..." value={formData.whyJoin} onChange={handleInputChange}></textarea>
                                    </div>

                                    <button
                                        type="submit"
                                        className="careers-modal-submit"
                                        disabled={formStatus === "submitting"}
                                    >
                                        {formStatus === "submitting" ? "Submitting..." : "Submit Application"}
                                    </button>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            )}
            <section className="diversity-section" ref={diversityInclusionRef}>

                {/* TITLE */}
                <h2 className="div-title">
                    Built on Respect. Powered by Diversity.
                </h2>

                {/* DIVIDER */}
                <div className="career-divider">
                    <span className="line left"></span>
                    <span className="logo-dot"><img src={minLogo} alt="" /></span>
                    <span className="line right"></span>
                </div>

                {/* SUBTEXT */}
                <p className="div-subtitle">
                    We believe diverse teams build better science. Viyash is committed to creating an environment
                    where every individual is respected, valued, and empowered to contribute their best —
                    regardless of background or identity.
                </p>

                {/* MAIN GRID */}
                <div className="div-grid">

                    {/* LEFT IMAGE */}
                    <div className="div-image">
                        <img src={teamImage} alt="team" />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="div-right">

                        <div className="div-card">
                            <div className="div-card-icon">
                                <img src={equalIcon} alt="Equal" />
                            </div>
                            <div style={{ marginBottom: "10px" }}>
                                <h4>Equal Opportunity Employer</h4>
                                <p>All roles are open to candidates regardless of gender, caste, religion, or nationality.</p>
                            </div>
                        </div>

                        <div className="div-card">
                            <div className="div-card-icon">
                                <img src={genderIcon} alt="Gender" />
                            </div>
                            <div>
                                <h4>Gender Diversity & Inclusion</h4>
                                <p>Active programs to increase women representation across manufacturing and leadership roles.</p>
                            </div>
                        </div>

                        <div className="div-card">
                            <div className="div-card-icon">
                                <img src={safeIcon} alt="Safe" />
                            </div>
                            <div>
                                <h4>Safe & Respectful Workplace</h4>
                                <p>Zero tolerance for discrimination, harassment, or unsafe working conditions at any site.</p>
                            </div>
                        </div>

                        <div className="div-card">
                            <div className="div-card-icon">
                                <img src={ethicalIcon} alt="Ethical" />
                            </div>
                            <div>
                                <h4>Ethical Governance & Compliance</h4>
                                <p>Global Code of Conduct governs all employee interactions and business relationships.</p>
                            </div>
                        </div>

                        <div className="div-card">
                            <div className="div-card-icon">
                                <img src={internationalIcon} alt="International" />
                            </div>
                            <div>
                                <h4>International Workforce</h4>
                                <p>Teams spanning India, Europe, and LATAM — bringing diverse perspectives and expertise.</p>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <section className="app-section" ref={applyNowRef}>

                <h2 className="app-title">Submit Your Application</h2>

                <div className="career-divider">
                    <span className="line left"></span>
                    <span className="logo-dot"><img src={minLogo} alt="dot" /></span>
                    <span className="line right"></span>
                </div>

                <p className="app-subtitle">
                    Join a globally integrated pharmaceutical enterprise shaping the future of health
                </p>

                <div className="app-card">
                    <div className="app-header">
                        <img src={build} alt="build" />
                        <div className="app-header-text">
                            <h3>Viyash Scientific Limited — Career Application</h3>
                            <p>All fields marked * are mandatory</p>
                        </div>
                    </div>

                    <form className="app-form" onSubmit={handleFormSubmit}>

                        <div className="grid">

                            <div>
                                <label>Full Name *</label>
                                <div className="input-with-icon">
                                    <img src={nameIcon} alt="" className="input-icon" />
                                    <input
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                        placeholder="Your full name"
                                    />
                                </div>
                                {errors.fullName && <span className="error-text">{errors.fullName}</span>}
                            </div>

                            <div>
                                <label>Email Address *</label>
                                <div className="input-with-icon">
                                    <img src={mailIcon} alt="" className="input-icon" />
                                    <input
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                        placeholder="your@email.com"
                                    />
                                </div>
                                {errors.email && <span className="error-text">{errors.email}</span>}
                            </div>

                            <div>
                                <label>Phone Number *</label>
                                <div className="input-with-icon">
                                    <img src={phoneIcon} alt="" className="input-icon" />
                                    <input
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                        placeholder="+91 XXXXX XXXXX"
                                    />
                                </div>
                                {errors.phoneNumber && <span className="error-text">{errors.phoneNumber}</span>}
                            </div>

                            <div>
                                <label>Current Location</label>
                                <div className="input-with-icon">
                                    <img src={locationIcon} alt="" className="input-icon" />
                                    <input
                                        name="location"
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                        placeholder="City, State / Country"
                                    />
                                </div>
                            </div>

                            <div>
                                <label>Position Applying For *</label>
                                <div className="input-with-icon">
                                    <img src={appIcon} alt="" className="input-icon" />
                                    <input
                                        name="position"
                                        value={formData.position}
                                        onChange={handleInputChange}
                                        type="text"
                                        placeholder="Enter position (letters only)"
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                    />
                                </div>
                                {errors.position && <span className="error-text">{errors.position}</span>}
                            </div>

                            <div>
                                <label>Total Experience</label>
                                <div className="input-with-icon">
                                    <img src={timeIcon} alt="" className="input-icon" />
                                    <select
                                        name="experience"
                                        value={formData.experience}
                                        onChange={handleInputChange}
                                        style={{ color: "#1a1a1a", fontSize: "14px" }}
                                    >
                                        <option value="" disabled selected></option>
                                        <option value="Fresher">Fresher</option>
                                        <option value="1 Years">1+ Years</option>
                                        <option value="3 Years">3+ Years</option>
                                        <option value="5 Years">5+ Years</option>
                                        <option value="10 Years">10+ Years</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <label>Current Company</label>
                                <div className="input-with-icon">
                                    <img src={companyIcon} alt="" className="input-icon" />
                                    <input className="input-text" style={{ color: "rgba(26, 26, 26, 0.50)", fontSize: "14px" }} placeholder="Current or last employer" />
                                </div>
                            </div>

                            <div>
                                <label>LinkedIn Profile</label>
                                <div className="input-with-icon">
                                    <img src={linkedinIcon} alt="" className="input-icon" />
                                    <input className="input-text" style={{ color: "rgba(26, 26, 26, 0.50)", fontSize: "14px" }} placeholder="linkedin.com/in/yourprofile" />
                                </div>
                            </div>

                            <div>
                                <label style={{ color: "#4A5565" }}>Upload Resume * <span className="label-note" style={{ color: "#99A1AF" }}>(PDF / DOC / DOCX)</span></label>
                                <div className={`upload-box ${errors.resume ? 'error' : ''}`}>
                                    <input type="file" className="file-input" onChange={(e) => handleFileChange(e, "resume")} accept=".pdf,.doc,.docx" />
                                    <FiUpload className="upload-icon" />
                                    <p>{resumeName || "Drag & drop or browse"}</p>
                                </div>
                                {errors.resume && <span className="error-text">{errors.resume}</span>}
                            </div>

                            <div >
                                <label>Cover Letter <span className="label-note" style={{ color: "#99A1AF" }}>(Optional)</span></label>
                                <div className="upload-box">

                                    <input type="file" className="file-input" onChange={(e) => handleFileChange(e, "coverLetter")} accept=".pdf,.doc,.docx" />
                                    <div>
                                        <FiFileText className="upload-icon" />
                                    </div>

                                    <p>{coverLetterName || "Drag & drop or browse"}</p>
                                </div>
                            </div>

                        </div>

                        <div className="full">
                            <label>Why do you want to join Viyash?</label>
                            <textarea
                                name="whyJoin"
                                value={formData.whyJoin}
                                onChange={handleInputChange}
                                placeholder="Share what excites you about Viyash Scientific and this opportunity..."
                                style={{ color: "#1a1a1a" }}
                            ></textarea>
                        </div>
                        <div className="policy" style={{ marginTop: "30px", marginBottom: "28px" }}>
                            I agree to the <span>Privacy Policy</span> and consent to Viyash Scientific Limited
                            processing my personal data for recruitment purposes. Data will be stored for a maximum
                            of 12 months per applicable regulations.
                        </div>


                        <button type="submit" className="submit-btn" disabled={formStatus !== "idle"}>
                            {formStatus === "submitting" ? "Submitting..." : formStatus === "success" ? "Application Sent! ✓" : "Submit Application →"}
                        </button>

                        <p className="note">
                            Our talent team reviews every application. Expected response: 5–7 business days.
                        </p>

                    </form>
                </div>
            </section >
            <section className="adv-section">

                <h2 className="adv-title">The Viyash Advantage</h2>

                <div className="adv-divider">
                    <span className="line left"></span>
                    <img src={minLogo} alt="" />
                    <span className="line right"></span>
                </div>

                <p className="adv-subtitle">
                    Four core pillars that define the Viyash employee experience
                </p>

                <div className="adv-grid">
                    {data.map((item, index) => (
                        <div className={`adv-card ${item.color}`} key={index}>

                            <img src={item.image} alt="icon" />

                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>

                        </div>
                    ))}
                </div>

            </section>

        </div >
    );
};

export default Careers;
